import { render, staticRenderFns } from "./portadoresSaldos.vue?vue&type=template&id=1689bef9"
import script from "./portadoresSaldos.vue?vue&type=script&lang=js"
export * from "./portadoresSaldos.vue?vue&type=script&lang=js"
import style0 from "./portadoresSaldos.vue?vue&type=style&index=0&id=1689bef9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports